import md from '@/routes/middlewares';

import ComponentPage from '@/views/ComponentPage.vue';
import LegionellaRiskAssessment from '@/views/LegionellaRiskAssessment';
import LegionellaRiskAssessmentPage from '@/views/LegionellaRiskAssessmentPage';
import RiskAnalysis from '@/views/RiskAnalysis.vue';
import RiskAnalysisPage from '@/views/RiskAnalysisPage.vue';

const component = {
    path: 'components/:componentId',
    component: ComponentPage,
    meta: {
        middlewares: [
            md.getComponentInfo,
        ],
    },
    children: [
        // LEGIONELLA
        {
            path: 'assessment/add',
            name: 'newAssessmentComponent',
            component: LegionellaRiskAssessment,
        },
        {
            path: 'assessment/:assessmentId',
            component: LegionellaRiskAssessmentPage,
            redirect: { name: 'assessmentComponent' },
            meta: {
                middlewares: [
                    md.getLegionellaRiskAssessment,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'assessmentComponent',
                    component: LegionellaRiskAssessment,
                },
            ],
        },
        // RISK ANALYSIS
        {
            path: 'riskAnalyses/add',
            name: 'newRiskAnalysisComponent',
            component: RiskAnalysis,
        },
        {
            path: 'riskAnalyses/:riskAnalysisId',
            component: RiskAnalysisPage,
            redirect: { name: 'riskAnalysisComponent' },
            meta: {
                middlewares: [
                    md.getRiskAnalysisInfo,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'riskAnalysisComponent',
                    component: RiskAnalysis,
                },
            ],
        },
    ],
};

export default component;
